import React from 'react'
import ReactDOM from 'react-dom'
import createStore from './store/createStore'
import counterpart from 'counterpart'
import ES from 'dictionaries/es.json'
import EN from 'dictionaries/en.json'
import { reloadApp } from 'utilities/session-utils'
import { getLanguage } from 'store/modules/module_settings'
import protocols from './common-protocols';

import './styles/main.scss'

// Store Initialization
// ------------------------------------
const store = createStore(window.__INITIAL_STATE__)

// Render Setup
// ------------------------------------
const MOUNT_NODE = document.getElementById('root')
const language = localStorage.getItem('language') || "es";
counterpart.registerTranslations('es', ES);
counterpart.registerTranslations('en', EN);
console.log(language, store.getState().settings.language)
counterpart.setLocale(language || store.getState().settings.language)

counterpart.onLocaleChange(function(newLocale, oldLocale) {
  localStorage.setItem('language', newLocale);
  reloadApp();
});
store.dispatch(getLanguage());

let render = () => {
  const App = require('./components/App').default
  const routes = require('./routes/index').default(store)

  ReactDOM.render(
    <App store={store} routes={routes} />,
    MOUNT_NODE
  )
}

// Development Tools
// ------------------------------------
if (__DEV__) {
  if (module.hot) {
    const renderApp = render
    const renderError = (error) => {
      const RedBox = require('redbox-react').default

      ReactDOM.render(<RedBox error={error} />, MOUNT_NODE)
    }

    render = () => {
      try {
        renderApp()
      } catch (e) {
        console.error(e)
        renderError(e)
      }
    }

    // Setup hot module replacement
    module.hot.accept([
      './components/App',
      './routes/index',
    ], () =>
      setImmediate(() => {
        ReactDOM.unmountComponentAtNode(MOUNT_NODE)
        render()
      })
    )
  }
}

// Let's Go!
// ------------------------------------
if (!__TEST__) render()



// WEBPACK FOOTER //
// ./src/main.js